import Vue from 'vue'
import Vuex from 'vuex'
import pointsListStore from '@/store/pointsListStore'
import configStore from '@/store/configStore'
import snackbarStore from '@/store/snackbarStore'
import facilityStore from '@/store/facilityStore'
import userStore from '@/store/userStore'
import maintenanceRecordStore from '@/store/maintenanceRecordStore'
import urlStore from '@/store/urlStore'
import notificationStore from '@/store/notificationStore'
import whiteboardStore from '@/store/whiteboardStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pointsListStore,
    configStore,
    snackbarStore,
    facilityStore,
    userStore,
    maintenanceRecordStore,
    urlStore,
    notificationStore,
    whiteboardStore
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
